export function loading (state, value) {
  state.loading = !!value
}
